<template>
    <div>
        <span v-if="!!template.id">({{ template.name }})</span>
        <a v-if="!!template.id" title="Cancel" href class="uk-icon-button uk-button-mini uk-icon-close" @click.prevent="template_editor_close"></a>
        <a v-if="savable" title="Save" href :class="{'uk-button-primary': dirty}" class="uk-icon-button uk-button-mini uk-icon-save" @click.prevent="template_editor_save"></a>

        <vk-modal :show="template_name!==null" @clickOut="template_name_close" @keyEsc="template_name_close" class="uk-text-left">
            <a class="uk-modal-close uk-close" @click.prevent="template_name_close"></a>
            <div class="uk-modal-header">
                <h2 v-if="category === 'filters'">Saved Filter Name</h2>
                <h2 v-else>Template Name</h2>
            </div>

            <div class="uk-modal-body">
                <input type="text" v-model="template_name" @focus="autoselect_action" class="uk-width-1-1">
                <p v-if="template_name_exists" class="uk-form-help-block">This name already exists. If you proceed with the save, the existing <span v-if="category === 'filters'">saved filter</span><span v-else>template</span> will be replaced.</p>
            </div>

            <div class="uk-modal-footer uk-text-center">
                <vk-button size="large" @click.native.prevent="template_name_close">Cancel</vk-button>
                <vk-button color="primary" size="large" :disabled="!template_name||template_name_exists" @click.native.prevent="template_name_save">Save</vk-button>
            </div>
        </vk-modal>
    </div>
</template>

<script type="text/javascript">
export default {
    watch: {
        clone: "template_clone"
    },
    methods: {
        template_clone () {
            this.template_name = this.clone ? this.clone.name : null
        },
        template_editor_close () {
            this.$emit("stop-editing")
        },
        template_editor_save () {
            if(this.clone && !this.clone.name) this.template_name = null
            else if(!this.clone && !this.template.name) this.template_name = ""
            else this.$emit("save")
        },
        template_name_close () {
            this.template_name = null
        },
        autoselect_action (event) {
            event.target.select()
        },
        template_name_save () {
            if(this.clone) this.clone.name = this.template_name
            else this.template.name = this.template_name
            this.template_editor_save()
            this.template_name_close()
        }
    },
    computed: {
        /*
        ...mapGetters({
            preferences: 'user_preference_records'
        }),
        */
        user_preference_records () {
            return []
        },
        templates () {
            if(!this.preferences) return []
            return this.preferences.filter(preference => {
                return (preference.category === this.category) && (preference.entity === this.entity)
            })
        },
        template_name_exists () {
            if(!this.template_name) return false
            return !!this.templates.find(template => template.name === this.template_name)
        }
    },
    props: {
        entity: {
            type: String,
            required: true
        },
        template: {
            type: Object,
            required: true
        },
        clone: {
            type: Object,
            default () {
                return null
            }
        },
        savable: {
            type: Boolean,
            default: false
        },
        dirty: {
            type: Boolean,
            default: false
        },
        category: {
            type: String,
            default: "export-columns" // "export-columns" or "filters"
        }
    },
    data () {
        return {
            template_name: null
        }
    }
}
</script>
